import { MwLoadOptions } from 'app/models/load-options.model';
import { DeviationApiModel } from 'app/models/deviation-api.model';
import { createAction, props } from '@ngrx/store';
import { MwPayloadModel } from 'app/models/payload.model';

export const loadDeviations = createAction(
  '[Deviations] Load',
  props<{ loadOptions?: MwLoadOptions }>()
);

export const loadDeviationsSuccess = createAction(
  '[Deviations] Load Successful',
  props<{ response: MwPayloadModel<DeviationApiModel[]> }>()
);

export const loadDeviationsFailure = createAction(
  '[Deviations] Load Failure',
  props<{ error: any }>()
);
